// @owners { team: patients-team }
export const parsePrepItems = (prepItems: string | null | undefined): string[] => {
  return typeof prepItems === 'string' && prepItems.trim() !== ''
    ? prepItems.split(',').map((item) => item.trim())
    : [];
};
